export default __webpack_public_path__ + "static/media/EM0760.34I-22661_-15272_0.e2f63c82.jpg";